<template>
    <div class="minHeight">
        <micro-class-screen v-bind:isShowStyle="true" v-bind:fromIndexRes="fromIndexResouresData" @goMaterialId="goMaterialId"></micro-class-screen>
        <div id="content" class="boxs">
            <directory-tree class=""></directory-tree>
            <tab-view class="" :toMaterialId="materialId" @isplay="isplay" @showPlayer="showPlayer" @isUpload="isUpload" @upLoadData="upLoadData"></tab-view>
        </div>
        <paly-material v-show="isPlayMaterial" @closePlayer="closePlayer"></paly-material>
        <video-player v-if="isPlayer" @closePlayer="closePlayer"></video-player>
        <!-- 上传资源组件 -->
        <up-load v-if="isShowUpload" @closeUpload="closeUpload" :datas="datas"></up-load>
    </div>

</template>
<script>
import MicroClassScreen from '../MicroClassScreen/synchronizeScreen.vue'
import TabView from '../SRTabView/srTabView.vue'
import DirectoryTree from '../DirectoryTree/DirectoryTree.vue'
import palyMaterial from '../playMaterial/playMaterial.vue'
import VideoPlayer from '../videoPlayer/viderPlayer.vue'
import upLoad from '../upLoad/upLoad.vue'
export default {
    name:'SynchronizeResources',
    props:{
      fromIndexResouresData:{
        type:Object,
        default:{'isFromIndexSyn':null,'subjectId':80,'routerMicroName':null}
      }
    },
    data(){
        return{
            materialId:362,
            isPlayMaterial:false,
            isPlayer:false,
            isShowUpload:false,                             //是否显示上传组件  false 不显示
            datas:null
        }
    },
    mounted() {
      this.$nextTick(()=>{
        $(document).scrollTop(0);
      })
    },
    methods:{
        goMaterialId(msg){
            this.materialId = msg;
        },
        isplay(msg){
            this.isPlayMaterial = msg;
        },
        closePlayer(msg){
            this.isPlayMaterial = msg;
            this.isPlayer = msg;
        },
        showPlayer(obj){
            this.isPlayer = obj;            //打开播放器  ture
        },
        isUpload(obj){
            this.isShowUpload = obj;        //打开上传组件
        },
        closeUpload(msg){
            this.isShowUpload = msg;
        },
        upLoadData(msg){
            this.datas = msg;
        }
    },
    components:{MicroClassScreen,TabView,DirectoryTree,palyMaterial,VideoPlayer,upLoad}
}
</script>
<style lang="">
    .boxs{
        display: flex;
        flex-direction: row;
        margin-top:22px!important;
    }
</style>



// WEBPACK FOOTER //
// src/components/SynchronizeResources/SynchronizeResources.vue